import React from 'react'
import '../../css/promocion.css'
import promo3 from '../../assets/images/promociones/banner-queNoPare.webp'
import lateralPromo1 from '../../assets/images/promociones/bfpass.webp'
import lateralPromo2 from '../../assets/images/promociones/adulto-mayor.png'
import { Outlet, Link } from "react-router-dom";
import whatsapp from '../../assets/images/chat.svg'
import formulario from '../../assets/images/formulario-de-contacto.svg'
import mapa from '../../assets/images/mapa.svg'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next';


export default function Promo14() {

    const { t } = useTranslation('promo3');
  return (
   <>

    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                <h3>{t('title')}</h3>
                <p>¡Que no pare la carga!</p>
                </div>                
            </div>
        </div>
    </section>   
    
    <section className='container'>
        <div className='banner-header-promo'>
            <img src={promo3} alt='buen-fin-bajaferries' />
        </div>
    </section>

    <section className='sectionPromo_content'>
        <div className='container'>
            <div className='box_promo'>
                <div className='content_text_promo'>
                    <div className='content_promo'>
                        
                        <p>Este mes, súmate a la fiesta del ahorro y mueve tu carga con un 20% de descuento en <strong>viaje sencillo o redondo</strong> para unidades tipo Thorton y Doble Rodado. </p>
                        <p>Válido únicamente en ventas de contado realizadas a través de los canales autorizados de Baja Ferries, incluyendo la línea de reservaciones <a href="tel:8003377437" rel="noopener noreferrer" style={{color:'#225981'}}> 800‑FERRIES (337‑7437) </a>  y puntos de venta oficiales.</p>

                     
                        <div className='content_promo_btn'>                                                
                            <a className='cta_promo' href="tel:8003377437" rel="noopener noreferrer"><span >{t('btn1')} </span></a> 
                            <a target="_blank" className='cta_promo' rel='noopener noreferrer' href='https://wa.me/5218003377437?text=Me%20interesa%20una%20cotización'>{t('btn2')}  </a>
                        </div>                         
                    </div>
                    
                    <div className='content_promo condiciones-promo'>
                        <h4>{t('text4')}</h4>
                        {/*<p>El tiempo se acaba, ¡Lugares limitados hasta agotar existencias!.</p>*/}
                        <ul>                            
                            <li>•  Promoción válida exclusivamente para viaje redondo de carga en unidades tipo Torton y Doble Rodado. No aplica para vehículos turísticos, motocicletas o transporte de pasajeros. </li>
                            <li>•  No aplica para pasajeros sin unidad registrada. </li>
                            <li>•  Vigencia para viajes realizados del 1 al 27 de marzo de 2026 en ambas rutas operadas por Baja Ferries. </li>
                            <li>•  El descuento no aplica sobre impuestos, cargos portuarios, seguros ni servicios adicionales.</li>

                            <li>•  Promoción sujeta a disponibilidad de espacio para carga en las salidas programadas. </li>
                            <li>•  Esta promoción no es acumulable con otras promociones, descuentos, convenios, tarifas especiales o clientes de crédito. </li>
                            <li>•  La promoción no es transferible ni canjeable por efectivo u otros beneficios.</li>
                            <li>•  Cambios, reembolsos y cancelaciones se regirán por las políticas comerciales vigentes de Baja Ferries al momento de la compra. En caso de cambio de fecha o ruta, el descuento podría perder su vigencia y aplicarse la tarifa disponible en ese momento.</li>
                            <li>•  Baja Ferries se reserva el derecho de modificar, suspender o cancelar la promoción en cualquier momento sin previo aviso, respetando las reservaciones ya pagadas y confirmadas dentro del periodo de vigencia.</li>
                                 
                        </ul>
                    </div>
                    {/*<div className='content_promo btn-termino-condiciones'>
                    <Link to="/condiciones-de-servicio">Consulta términos y condiciones</Link> 
                    </div>*/}
                </div>
                <div className='content_contador_promo'>
                    <div className='content_promo'>
                        {/*}
                        <div className='content-isotipo'>
                            <img src={bfIso} alt='bf-isotipo'/>
                        </div>
                        <div>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                consequat.
                            </p>

                        </div>
                        <div>
                            <Temporizador targetDate={targetDate} />
                        </div>
                          <div className='lateral-promo'>
                            <Link to="/bf-pass">
                                <img src={lateralPromo1} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                        */}
                        <h4 className='otras-promos'>{t('text6')} </h4>
                      
                        <div className='lateral-promo'>
                            <Link to="/promo-adulto-mayor">
                                <img src={lateralPromo2} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>        
    </section>
    
    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={formulario} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            
                            <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn1')}  </a>  
                           
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/antes-de-viajar">{t('cta_btn2')}  </Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/tarifas">{t('cta_btn3')}</Link>                     
                        </div>
                    </div>
                </div>
            </div>

        </div>
   </section>

        <Outlet />

    <Footer />
   
   </>
  )
}
